import React from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import isEqualWith from 'lodash/isEqualWith'
import sortBy from 'lodash/sortBy'

import { CartItem } from '../Cart'
import { PurchaseOrderFormGroup } from '../PaymentMethod'
import { TranslationUtility } from "../../../util/translationUtility";

import {
   CheckoutSection, 
   SpinnerWhenInvalid
} from '../../components'

const toMoneyString = (n) => n.toLocaleString('en-US', { style: 'currency', currency: 'USD' })

// @param summary: an array of strings, alternating between labels and values. 
// @returns a row of the summary for each pair of elements in the summary
const mapSummaryToRows = (summary) => {
  const last = summary.length - 2;
  const { children } = summary.reduce((acc, cur) =>
    (acc.i % 2 === 0)                                                // check if cur is a multiple of 2

      ? { children: acc.children, i: acc.i + 1 }                      // if so, then skip this element
      // (it's a label we'll add on the next iteration)

      : {                                                             // if cur is an odd number, then add a row
        children: [...acc.children, (
          <tr key={acc.i} style={last > acc.i ? {} : { fontWeight: 'bold'}}>
              <td className="summary-label" style={{ textAlign: 'right', width: '50%' }}>
                {summary[acc.i - 1]}:                           
              </td>
              <td className="summary-amount" style={{ textAlign: 'right', width: '50%' }}>
                {cur}
              </td>
          </tr>
        )],
          i: acc.i + 1
    }, { children: [], i: 0 }); // init reduction 
  return children;
}

const cartItemPropertiesToCompare = ['Id', 'Price', 'SKU', 'Quantity'];
function cartItemComparer(first, second) {
  cartItemPropertiesToCompare.every((propName) => first && second && (first[propName] === second[propName]));
}


const placeOrderDetailsChanged = (prevProps, newProps) =>
    !isEqualWith(sortBy(prevProps.cart, ['Id']), sortBy(newProps.cart, ['Id']), cartItemComparer) ||
    !isEqual(prevProps.shippingAddress, newProps.shippingAddress) ||
    prevProps.shippingOptionId !== newProps.shippingOptionId ||
    prevProps.couponCode !== newProps.couponCode;

class CheckoutSummary extends React.Component {
  constructor(props) {
    super(props);
    this.translationUtility = new TranslationUtility(props.localizationItems);
  }
  
  componentDidUpdate(prevProps) {
    let prevCountryCode = prevProps.shippingAddress && prevProps.shippingAddress.CountryCode || "";
    let countryCode = this.props.shippingAddress && this.props.shippingAddress.CountryCode || "";
    if (prevCountryCode !== countryCode) {
        this.props.onShippingCountryChanged();
    }      
    if (placeOrderDetailsChanged(prevProps, this.props)) {
      this.props.updateSummary(this.props.placeOrderDetails);
    }
  }

    render() {
    if (this.props.placeOrderDetails.HasRestrictedItems) {
        return (
            <div className="alert alert-danger">{this.translationUtility.translateResourceString("/Checkout/RestrictedItems")}</div>
            );
    }
    const summary = this.props.summary;
    const rows = mapSummaryToRows(summary);      
    return (
        <CheckoutSection label={this.translationUtility.translateResourceString("/Checkout/Summary")} hidden={false}>
          <PurchaseOrderFormGroup poNumber={this.props.placeOrderDetails.poNumber} onChange={(e) => this.props.onPoChange(e.target.value)}/>
        <hr />
          <SpinnerWhenInvalid isInvalid={this.props.summaryIsUpdating}>
            <table style={{ margin: 'auto' }}>
              <tbody>
                {rows}
              </tbody>
            </table>
          </SpinnerWhenInvalid>
      </CheckoutSection>
      );
  }
}

CheckoutSummary.defaultProps = {
    summaryIsUpdating: false
}

CheckoutSummary.propTypes = {
  cart: PropTypes.arrayOf(CartItem.propTypes),
  couponCode: PropTypes.string,
  onGetSummaryError: PropTypes.func.isRequired,
  placeOrderDetails: PropTypes.object.isRequired,
  shippingAddress: PropTypes.object,
  summary: PropTypes.arrayOf(PropTypes.string).isRequired,
  summaryEndpoint: PropTypes.string.isRequired,
  summaryIsUpdating: PropTypes.bool,
  localizationItems: PropTypes.array.isRequired,
  hasRestrictedItems: PropTypes.bool,
  onShippingCountryChanged: PropTypes.func.isRequired  
}

export default CheckoutSummary


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Summary/CheckoutSummary.jsx